import { getBackendErrorMessage } from '@/utils/errorHandler';
import Axios from '../../utils/axios';

export type DocumentType = 'tahunan' | '5_tahunan';
export type StnkStatus = 'kadaluwarsa' | 'sangat_mendesak' | 'akan_habis' | 'aman';

export interface StnkStats {
  total: number;
  expired: number;
  within45d: number;
  safe: number;
}

export interface StnkListItem {
  id: string;
  plateNumber: string;
  oemName: string;
  modelName: string;
  documentType: DocumentType;
  expiryDate: string;
  daysRemaining: number;
  status: StnkStatus;
  fileUrl: string | null;
  isActive: boolean;
}

export interface StnkPagination {
  page: number;
  size: number;
  total: number;
  lastPage: number;
}

export interface GetStnkListResult {
  data: StnkListItem[];
  pagination: StnkPagination;
}

export interface RenewalResult {
  id: string;
  expiryDate: string;
  daysRemaining: number;
  status: StnkStatus;
  updatedAt: string;
}

// Filters shared by the list and the CSV export, so the file always matches
// what is on screen.
export interface StnkListFilters {
  view?: 'attention' | 'all';
  type?: DocumentType;
  search?: string;
  sort?: string;
  order?: 'asc' | 'desc';
}

export interface GetStnkListParams extends StnkListFilters {
  page?: number;
  size?: number;
}

export interface SaveRenewalPayload {
  new_expiry_date: string;
  file_url: string;
  notes?: string | null;
}

export const stnkApi = {
  getStats: async (): Promise<StnkStats> => {
    const res = await Axios.get<{ data: StnkStats }>('/v1/stnk/stats');
    return res.data.data;
  },

  getList: async (params?: GetStnkListParams): Promise<GetStnkListResult> => {
    const res = await Axios.get<GetStnkListResult>('/v1/stnk', { params });
    return res.data;
  },

  downloadCsv: async (filters?: StnkListFilters): Promise<Blob> => {
    try {
      const res = await Axios.get('/v1/stnk/download/csv', {
        params: filters,
        responseType: 'blob',
      });
      return res.data;
    } catch (error: any) {
      throw new Error(getBackendErrorMessage(error));
    }
  },

  saveRenewal: async (vehicleDocumentId: string, payload: SaveRenewalPayload): Promise<RenewalResult> => {
    const res = await Axios.post<{ data: RenewalResult }>(
      `/v1/stnk/${vehicleDocumentId}/renewal`,
      payload
    );
    return res.data.data;
  },

  deactivate: async (vehicleDocumentId: string): Promise<void> => {
    await Axios.patch(`/v1/stnk/${vehicleDocumentId}/deactivate`);
  },
};
